<div class="ai-summary-loading">
  <div class="ai-summary-header">
    <div class="row1 loading-header"></div>
    <div class="ai-summary-badge">
      <mat-icon svgIcon="sparkles"></mat-icon>
      <span>Generating summary...</span>
    </div>
  </div>
  <div class="ai-summary-loading-body">
    <div class="row1"></div>
    <div class="row1"></div>
    <div class="row1"></div>
    <div class="row1"></div>
    <div class="row1"></div>
  </div>
</div>
